import { combineReducers } from 'redux'
import knowledgeBuildersList from 'app/store/reducers/theater/knowledge-builders.reducer'
import knowledgeBuilder from 'app/store/reducers/theater/knowledge-builder.reducer'

const TheaterReducer = combineReducers({
  knowledgeBuildersList,
  knowledgeBuilder,
})

export default TheaterReducer
